exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".gold-standard-observations {\n  min-height: 100%;\n  flex: 1 0 auto;\n  padding-bottom: 30px;\n}\n.gold-standard-observations tr.highlight {\n  color: #ffa723;\n}\n.gold-standard-observations p {\n  font-size: 16px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./frontend/olos/styles/GoldStandardObservations.styl
// module id = 1897
// module chunks = 1